import { camelize } from 'humps';
import INPUT_TYPES from './constants';
import { getCompatibleDateFormat } from './dates';

const { DATE_TIME } = INPUT_TYPES;
export default (fields, customFields) => {
  const parsedFields = {};
  Object.keys(fields).forEach((field) => {
    if (customFields[field]) parsedFields[camelize(customFields[field].name)] = fields[field];
  });
  return parsedFields;
};

const defaultAnswers = {
  // TODO?
  // 1951: 'No', // accompanying
  // 1955: 'No', // joining
  // 1952: 'No', // same room
};

export const defaultAttendeeFieldsValues = (fields, customFields) => {
  const attendee = { customFields: {} };
  Object.keys(fields).forEach((field) => {
    // viene null por default, toca pasarlo a "No" para que se
    // muestre checked la opcion "No" en el radio button
    if (
      defaultAnswers[customFields[field].internalId]
    ) attendee.customFields[`_${field}`] = fields[field] || defaultAnswers[customFields[field].internalId];

    else if (customFields[field]?.default) attendee[customFields[field].name] = fields[field];
    else if (!!customFields[field]
      && !customFields[field].default) if (customFields[field]
      .inputType === DATE_TIME) {
      const { includeTime } = customFields[field];
      const value = getCompatibleDateFormat(fields[field], includeTime);
      attendee.customFields[`_${field}`] = value;
    } else attendee.customFields[`_${field}`] = fields[field];
  });
  return { attendee };
};

export const parseFieldsByInternalId = (fields = {}, customFields) => {
  const result = {};
  Object.keys(fields).forEach((field) => {
    if (customFields[field]) result[(customFields[field].internalId)] = customFields[field].id;
  });
  return result;
};
